
import { Link } from 'react-router-dom';

const FAQContact = () => {
  return (
    <section className="py-16 bg-slate-50 border-t border-slate-100">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="w-14 h-14 flex items-center justify-center rounded-full bg-amber-100 mx-auto mb-5">
          <i className="ri-customer-service-2-line text-amber-600 text-2xl"></i>
        </div>
        <h2
          className="text-2xl font-bold text-slate-800 mb-3"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Não encontrou a sua resposta?
        </h2>
        <p className="text-slate-500 text-sm leading-relaxed mb-8 max-w-md mx-auto">
          A nossa equipa está disponível todos os dias das 08h às 22h para responder a qualquer dúvida que tenha.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://wa.me/351962050526?text=Olá!%20Tenho%20uma%20dúvida%20sobre%20o%20alojamento."
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-7 py-3 rounded-full bg-green-500 text-white text-sm font-semibold hover:bg-green-600 transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            Falar no WhatsApp
          </a>
          <Link
            to="/contactos"
            className="flex items-center gap-2 px-7 py-3 rounded-full bg-slate-900 text-white text-sm font-semibold hover:bg-slate-700 transition-all shadow-md hover:shadow-lg cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-send-line text-lg"></i>
            Enviar Mensagem
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQContact;
